const LocalStorageConstants = {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    CUURENT_USERNAME: 'current_userName',
    CURRENT_USER: 'current_user'
};

export default LocalStorageConstants;